export default [
  {
    text: "modules",
    type: "section",
    modules: [
      {
        to: { name: "content-editor" },

        icon: "mdp-Content-Editor",
        text: "Content Editor",
        name: "content-editor"
      },
      {
        to: { name: "channel-creator" },

        icon: "mdp-Channel-Creator",
        text: "Channel Creator",
        name: "channel-creator"
      },
      {
        to: { name: "attribute-manager" },

        icon: "mdp-Attribute-Manager",
        text: "Attribute Manager",
        name: "attribute-manager"
      },
      {
        to: { name: "work-manager" },

        icon: "mdp-Work-Manager",
        text: "Work Manager",
        name: "work-manager"
      },
      {
        to: { name: "user-manager" },

        icon: "mdp-User-Manager",
        text: "User Manager",
        name: "user-manager"
      },
      {
        to: { name: "configuration-manager" },

        icon: "mdp-Configuration-Manager",
        text: "Configuration Manager",
        name: "configuration-manager"
      },
      {
        to: { name: "gpsr" },

        icon: "mdp-GPSR",
        text: "GPSR",
        name: "GPSR"
      },
      {
        to: { name: "translation-manager" },

        icon: "mdp-Translation-Manager",
        text: "Translation Manager",
        name: "translation-manager",
        featureStatusKey: "translationManagerEnabled"
      },
      {
        to: { name: "automation-server" },
        child: "automation-details",
        icon: "mdp-Automation-Server",
        text: "Automation Server",
        name: "automation-server"
      }
    ]
  },
  {
    text: "dataQuality",
    type: "section",
    modules: [
      {
        to: null,

        icon: "mdp-Quality-Gates",
        text: "Quality Gates"
      },
      {
        to: null,

        icon: "mdp-Media-Cleanup",
        text: "Media Cleanup"
      },
      {
        to: null,

        icon: "mdp-Article-Merge",
        text: "Article Merge"
      },
      {
        to: null,

        icon: "mdp-Report-Center",
        text: "Report Center"
      }
    ]
  },
  {
    text: "import",
    type: "section",
    popupChildrenWhenMinimized: true,
    icon: "mdp-Imports",
    hasGeneralRouteForChildren: true,
    featureStatusKey: "importEnabled",
    modules: [
      {
        to: { name: "create-import", params: { type: "Excel" } },

        icon: "mdp-Imports",
        text: "Excel",
        name: "Excel-import",
        featureStatusKey: "importEnabled"
      },
      {
        to: { name: "create-import", params: { type: "Text" } },

        icon: "mdp-Imports",
        text: "Text",
        name: "Text-import",
        featureStatusKey: "importEnabled"
      },
      {
        to: { name: "create-import", params: { type: "ExternalSource" } },

        icon: "mdp-Imports",
        text: "External source",
        name: "ExternalSource-import",
        featureStatusKey: "externalDataImportEnabled"
      },
      {
        to: { name: "create-import", params: { type: "BMEcat" } },

        icon: "mdp-Imports",
        text: "BMEcat®",
        name: "BMEcat-import",
        featureStatusKey: "importEnabled"
      }
    ]
  },
  {
    text: "export",
    type: "section",
    icon: "mdp-Exports",
    hasGeneralRouteForChildren: true,
    popupChildrenWhenMinimized: true,
    modules: [
      {
        to: { name: "create-export", params: { type: "Excel" } },

        icon: "mdp-Exports",
        text: "Excel",
        name: "Excel-export"
      },

      {
        to: { name: "create-export", params: { type: "Text" } },

        icon: "mdp-Exports",
        text: "Text",
        name: "Text-export"
      },

      {
        to: { name: "create-export", params: { type: "XML" } },

        icon: "mdp-Exports",
        text: "XML",
        name: "XML-export"
      },

      {
        to: { name: "create-export", params: { type: "JSON" } },

        icon: "mdp-Exports",
        text: "JSON",
        name: "JSON-export"
      },
      {
        to: { name: "create-export", params: { type: "BMEcat" } },

        icon: "mdp-Exports",
        text: "BMEcat®",
        name: "BMEcat-export"
      },
      {
        to: { name: "create-export", params: { type: "TradeProNext" } },

        icon: "mdp-Exports",
        text: "TradePro Connector",
        name: "TradeProNext-export"
      },
      {
        to: { name: "create-export", params: { type: "Ariba" } },

        icon: "mdp-Exports",
        text: "Ariba Connector",
        name: "Ariba-export",
        featureStatusKey: "aribaExportEnabled"
      }
    ]
  },
  {
    text: "printCatalogs",
    type: "section",
    modules: [
      {
        to: { name: "create-export", params: { type: "FastPage" } },

        icon: "mdp-FastPage",
        text: "FastPage",
        name: "FastPage-export",
        featureStatusKey: "fastpageExportEnabled"
      }
    ]
  }
];
